import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { SENTRY_ENVIRONMENT, SENTRY_TOKEN } from './config';
import { sentryTrivialErrors } from './errors';
import reportWebVitals from './reportWebVitals';
import { initMocks } from './test/server';

Sentry.init({
  dsn: SENTRY_TOKEN,
  environment: SENTRY_ENVIRONMENT,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  beforeSend(event) {
    if (event.environment !== 'production') return null;

    const errorMessage = event.exception?.values?.[0].value;
    if (errorMessage && sentryTrivialErrors.includes(errorMessage)) return null;

    return event;
  },
});

initMocks();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
